module.exports = __webpack_public_path__ + "static/media/role_inactive.2b1c14d4.svg";